import { useEffect, useState } from 'react';
import { fetchPublicOffer } from '../../infrastructure/api/public-offer.api';
import type { PublicOffer } from '../../application/types';

export function usePublicOffer() {
  const [offer, setOffer] = useState<PublicOffer | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    fetchPublicOffer()
      .then(next => {
        if (!cancelled) {
          setOffer(next);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setOffer(null);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setIsLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { offer, isLoading };
}
